<template>
  <div class="branch_container">
    <router-link
      tag="div"
      class="wrapper"
      v-for="item in list"
      :key="item.id"
      :to="item.path"
    >
      <i v-if="item.code" class="iconfont" v-html="item.code"></i>
      <img class="img" v-if="item.url" :src="item.url" :alt="item.label">
      <div class="text">{{ item.label }}</div>
    </router-link>
    <div class="em"></div>
    <div class="em"></div>
    <div class="em"></div>
    <div class="em"></div>
    <div class="em"></div>
  </div>
</template>

<script>
export default {
  name: 'Branch',
  data () {
    return {
      list: [{
        id: Math.random().toString(),
        code: '&#xe611;',
        label: '上海',
        path: '/branch/shanghai'
      }, {
        id: Math.random().toString(),
        code: '&#xe60d;',
        label: '天津',
        path: '/branch/tianjin'
      }, {
        id: Math.random().toString(),
        code: '&#xe615;',
        label: '香港',
        path: '/branch/xianggang'
      }, {
        id: Math.random().toString(),
        code: '&#xe609;',
        label: '辽宁大连',
        path: '/branch/dalian'
      }, {
        id: Math.random().toString(),
        code: '&#xe60e;',
        label: '江苏南京',
        path: '/branch/nanjing'
      }, {
        id: Math.random().toString(),
        code: '&#xe60c;',
        label: '山东青岛',
        path: '/branch/qingdao'
      }, {
        id: Math.random().toString(),
        code: '&#xe60c;',
        label: '山东烟台',
        path: '/branch/yantai'
      }, {
        id: Math.random().toString(),
        code: '&#xe60c;',
        label: '山东威海',
        path: '/branch/weihai'
      }, {
        id: Math.random().toString(),
        code: '&#xe619;',
        label: '浙江宁波',
        path: '/branch/ningbo'
      }, {
        id: Math.random().toString(),
        code: '&#xe606;',
        label: '湖北武汉',
        path: '/branch/wuhan'
      }, {
        id: Math.random().toString(),
        code: '&#xe617;',
        label: '湖南长沙',
        path: '/branch/changsha'
      }, {
        id: Math.random().toString(),
        code: '&#xe612;',
        label: '广东广州',
        path: '/branch/guangzhou'
      }, {
        id: Math.random().toString(),
        code: '&#xe612;',
        label: '广东深圳',
        path: '/branch/shenzhen'
      }, {
        id: Math.random().toString(),
        url: '/img/about/美国.png',
        label: '美国',
        path: '/branch/meiguo'
      }, {
        id: Math.random().toString(),
        url: '/img/about/日本.png',
        label: '日本',
        path: '/branch/riben'
      }, {
        id: Math.random().toString(),
        url: '/img/about/澳大利亚.png',
        label: '澳大利亚',
        path: '/branch/aodaliya'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.branch_container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    width: 150px;
    height: 130px;
    box-sizing: border-box;
    padding: 5px;
    border-radius: 3px;
    border: 1px solid #d6d6d6;
    position: relative;
    &:hover {
      cursor: pointer;
      color: #2d5092;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      .iconfont {
        color: #2d5092;
      }
    }
    .iconfont {
      color: #a0c1ff;
      font-size: 100px;
    }
    .img {
      width: 100px;
    }
    .text {
      position: absolute;
      bottom: 6px;
    }
  }
  .em {
    width: 150px;
  }
}
</style>
